export default __webpack_public_path__ + "static/media/musicDefaultPreview.5aa44181.svg";